import classNames from "classnames";
import classNamesBind from "classnames/bind";
import styles from "./Toggle.module.css";

const cx = classNamesBind.bind(styles);

export const Toggle = <T extends string>({
  items,
  selectedItem,
  onClickItem,
  className,
  ariaLabel,
}: {
  items: { label: string; value: T }[];
  selectedItem: T;
  onClickItem: (value: T) => void;
  className?: string;
  ariaLabel?: string;
}) => {
  return (
    <div className={classNames(className, cx("container"))} role="group" aria-label={ariaLabel}>
      {items.map((item, index) => (
        <button
          className={cx("item")}
          data-selected={JSON.stringify(selectedItem === item.value)}
          key={index}
          onClick={() => onClickItem(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};
